import axios from 'axios';

// Define state
const state = {
    reports: [],
};

// Define mutations
const mutations = {
    SET_REPORTS(state, { data }) {
        state.reports = data;
    }
};

const actions = {
    async fetchReports({ commit }) {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return { status: 'error', message: 'No token found' };
        }

        try {
            const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
            const response = await axios.get(`${baseUrl}/reports`, {
                headers: { Authorization: `Bearer ${userToken}` },
            });
            commit('SET_REPORTS', { data: response.data });
            return { status: 'success' };
        } catch (error) {
            let message = 'An error occurred';
            if (error.response) {
                message = error.response.data.error || message;
            }
            return { status: 'error', message };
        }
    },
};

const getters = {
  // 
};

// Export the module
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};